// extracted by mini-css-extract-plugin
export var logo = "_a5-2";
export var logoWrapper = "_a5-1";
export var strip = "_a5-0";